module.exports = __webpack_public_path__ + "img/7.ae19d90a.jpg";